import React from 'react';
import { FormattedMessage } from 'react-intl';
import RadioButton from '@rio-cloud/rio-uikit/lib/es/RadioButton';
import Tooltip from "@rio-cloud/rio-uikit/lib/es/Tooltip";
import OverlayTrigger from "@rio-cloud/rio-uikit/lib/es/OverlayTrigger";

interface RadioOption {
    id: string;
    label: string;
    value: any;
}

interface RadioButtonListProps {
    labelId: string;
    options: RadioOption[];
    value?: any;
    onChange: (value: string | null) => void;
    tooltipId?: string;
}

const RadioButtonListOTA: React.FC<RadioButtonListProps> = ({
    labelId,
    options,
    value,
    onChange,
    tooltipId
}) => {
    return (
        <div className='form-group'>
            <label className='control-label'>
                <FormattedMessage id={labelId}/>
            </label>
            {tooltipId && <OverlayTrigger
                key={1}
                placement={'right-start'}
                overlay={
                    <Tooltip id='tooltip' allowOnTouch>
                        <FormattedMessage id={tooltipId}/>
                    </Tooltip>
                }
            >
                <span className='rioglyph rioglyph-info-sign margin-left-5 label-info' style={{fontSize: '16px'}}
                      aria-hidden='true'></span>
            </OverlayTrigger>}
            <div className='display-flex'>
                {options.map((option) => (
                    <div key={option.id} className='margin-right-15'>
                        <RadioButton
                            checked={value === option.value}
                            onChange={() => onChange(option.value)}
                            label={<FormattedMessage id={option.label}/>}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RadioButtonListOTA;
